export default "__VITE_ASSET__CS2tEgY3__"